/**
 * add-reminder-modal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component } from "@angular/core";
import { Form, FormControl, Validators } from "@angular/forms";

import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";

// import { WatchlistService } from "./watchlist.service";

interface ReminderModalContext extends BSModalContext
{
	initialDate? : Date;
	hasImpliedLink? : boolean
}

export interface ReminderModalResult
{
	summary : string;
	triggerTime : Date;
	linkedRecord : boolean;
}

@Component({
	template: `
<div class="modal-header">
	<button
		type="button"
		class="close"
		(click)="dialog.dismiss()"
		aria-label="Close">
		<span aria-hidden="true">&times;</span>
	</button>
	<h4 class="modal-title">
		Add Reminder
	</h4>
</div>
<div class="modal-body">
	<div class="form-group">
		<label>Trigger time</label>
		<input
			type="datetime-local"
			class="form-control"
			[formControl]="triggerTime">
	</div>
	<div class="form-group">
		<label>Reminder memo</label>
		<input
			type="text"
			class="form-control"
			[formControl]="summary"
			placeholder="To-do, note, or other message...">
	</div>
	<div class="checkbox" *ngIf="dialog.context.hasImpliedLink">
    <label>
      <input type="checkbox" [formControl]="linkRecord">
			&nbsp; Link to the current record?
    </label>
		<p>This creates a connection between the reminder and the record so that it can be opened later.</p>
  </div>

	<p *ngIf="errorMessage" class="text-danger">{{errorMessage}}</p>
</div>
<div class="modal-footer">
	<button
		type="button"
		class="btn btn-primary"
		(click)="add()">
		Add
	</button>
	<button
		type="button"
		class="btn btn-default"
		(click)="dialog.dismiss()">
		Cancel
	</button>
</div>

  `,
	styles: [`.checkbox label {font-weight: bold;}`]
})
export class AddReminderModalComponent
	implements ModalComponent<ReminderModalContext>
{
	/**
	 * String container for validation errors to be displayed.
	 */
	public errorMessage : string;

	/**
	 * The text note associated with a new reminder.
	 */
	public summary : FormControl = new FormControl("", Validators.required);

	public linkRecord : FormControl = new FormControl(
		!!this.dialog.context.hasImpliedLink);

	/**
	 * The time a new reminder is scheduled for.
	 */
	public triggerTime : FormControl =
		new FormControl(null, Validators.required);

	constructor (public dialog : DialogRef<ReminderModalContext>)
	{
		if (dialog.context.initialDate)
		{
			this.triggerTime.setValue(dialog.context.initialDate);
		}
	}

	/**
	* Create a new reminder.
	*/
	public add () : void
	{
		if (this.triggerTime.invalid)
		{
			this.errorMessage = "You must enter a date to create a reminder!";
			return;
		}
		if (this.summary.invalid)
		{
			this.errorMessage =
				"You must enter a memo/label to create a reminder!";
			return;
		}

		const result : ReminderModalResult = {
			summary: this.summary.value,
			triggerTime: this.triggerTime.value,
			linkedRecord: this.linkRecord.value
		};

		this.dialog.close(result);
	}
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/watchlist/add-reminder-modal.component.ts